import {
	type LoaderFunctionArgs,
	type MetaFunction,
	useLoaderData,
} from 'react-router'
import { SiteShell } from '#app/components/site/SiteShell'
import { LegalPage } from '#app/components/site/legal'
import { PRIVACY_POLICY } from '#app/data/legal/privacy'
import { getAudience } from '#app/utils/site/audience.server'
import { siteContent } from '#app/utils/site/content'
import { siteLinks } from '#app/utils/site/site-links'
import { siteMeta } from '#app/utils/site/site-meta'

export const handle = { chrome: 'site' } as const
export const links = siteLinks()
export const meta: MetaFunction = () => siteMeta(siteContent.meta.privacy)

export async function loader({ request }: LoaderFunctionArgs) {
	return { audience: await getAudience(request) }
}

export default function PrivacyRoute() {
	const { audience } = useLoaderData<typeof loader>()
	return (
		<SiteShell audience={audience}>
			<LegalPage doc={PRIVACY_POLICY} />
		</SiteShell>
	)
}
